import { create } from "zustand";

export const useGalleryViewStore = create((set) => ({
  jeprinData: null,
  setJeprinData: (data) => set({ jeprinData: data }),
}));
